import { validationMessages } from "../common/validationMessages";
import * as Yup from "yup";

export interface InsuranceModel {
  expiryDate: string | null;
  daysRemaining: number | null;
  status: string;
}

export interface CarrierFormModel {
  carrierName: string;
  status: string;
  carrierAddress: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  country: string;
  phoneNumber: string;
  carrierEmail: string;
  scacCode: string;
  mcNumber: string;
  generalLiabilityExpiryDate: string;
  autoLiabilityExpiryDate: string;
  motorCargoExpiryDate: string;
  workmanCompExpiryDate: string;
  notes: string;
}

export interface CarrierDetailModel {
  carrierNumber: number;
  carrierName: string;
  status: string;
  carrierAddress: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  country: string;
  phoneNumber: string;
  carrierEmail: string;
  scacCode: string;
  mcNumber: string;
  generalLiability: InsuranceModel;
  autoLiability: InsuranceModel;
  motorCargo: InsuranceModel;
  workmanComp: InsuranceModel;
  notes: string;
  dateCreated: string;
  dateUpdated: string | null;
  userCreated: string;
  userUpdated: string | null;
  createdBy: string;
  updatedBy: string | null;
}

export const getCarrierInfoValidation = (): Yup.ObjectSchema<CarrierFormModel> => {
  return Yup.object().shape({
    carrierName: Yup.string()
      .max(30, validationMessages.max30chars)
      .required('Carrier Name is required'),
    status: Yup.string().required("Status is required"),
    email: Yup.string().max(60, "The value must be no more than 60 characters").email(validationMessages.notValid).required(validationMessages.required),
    phone: Yup.string()
      .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, validationMessages.notValid)
      .min(10, "Phone Number is required")
      .required('Phone is required'),
    streetAddress: Yup.string()
      .max(100, "The value must be no more than 100 characters")
      .required('Street Address is required'),
    city: Yup.string()
      .required('City is required'),
    stateProvince: Yup.string()
      .required('State/Province is required'),
    zipPostalCode: Yup.string()
      .min(5, "Zip code must be at least 5 characters")
      .max(10, "Zip code must be no more than 10 characters")
      .required('ZIP/Postal Code is required'),
    country: Yup.string()
      .required('Country is required'),

    scacCode: Yup.string()
      .required('SCAC Code is required'),
    motorCarrierNo: Yup.string()
      .required('MC Number is required'),

    generalLiabilityDate: Yup.string()
      .required('General Liability expiration date is required'),
    autoLiabilityDate: Yup.string()
      .required('Auto Liability expiration date is required')
  }).defined();
};
